import { Injectable, OnInit, Injector } from '@angular/core';
import { ParserService } from '../ws/ws.service';
import { environment } from '../../../../environments/environment';
import { IContentParser } from './content-parser';

import { WsService2 } from '../ws/ws.service';
@Injectable()
export class ContentParserService extends ParserService implements IContentParser {
    constructor(ws: WsService2) {
        console.log("Creating content parser service");
     super(ws);
    }
    callback;
    setCallback(c) {
        this.callback = c;
    }
    parseMessage(m) {
        switch (m.cmd) {
            case "recorderFile": this.onRecorderFilename(m); break;
        }
    }
    onRecorderFilename(m) {
        this.callback.onRecorderFilename(m.fileName);
    }

}



// WEBPACK FOOTER //
// /app/src/app/wb/services/content/content-parser.service.ts